import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LinkIcon from '@mui/icons-material/Link';
import XIcon from '@mui/icons-material/X';

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: theme.palette.text.primary,
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      display:'flex',
      marginLeft:'5px',
      alignItems:'center',
      justifyContent:'flex-start',
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

interface OwnProps{
  shareLink:string;
}

export default function SocialShareButton(props:OwnProps) {
  const{
    shareLink
  } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(null);
    const ahref = shareLink;
    const encodedAhref = encodeURIComponent(ahref);
    var link;
    switch (e.currentTarget.id) {
      case 'twitter':
        link = `https://twitter.com/intent/tweet?url=${encodedAhref}`
        window.open(link);
        break;  
      case 'copy':
        navigator.clipboard.writeText(ahref);
        break;  
      default:
        break;
    }
  };

  return (
    <div>
      <Button
        id="social-share-button"
        aria-controls={open ? 'social-share-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        disableElevation
        onClick={handleClick}
        style={{height:'44px',width:'150px'}}
        endIcon={<KeyboardArrowDownIcon />}
      >
        Share Entry
      </Button>
      <StyledMenu
        id="social-share-menu"
        MenuListProps={{
          'aria-labelledby': 'social-share-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem id='twitter' onClick={handleClose} disableRipple>
          <XIcon />
          Tweet
        </MenuItem>
        <MenuItem id='copy' onClick={handleClose} disableRipple>
          <LinkIcon />
          Copy Link
        </MenuItem>
      </StyledMenu>
    </div>
  );
}